import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.98.02A1 1 0 0 1 21.2 1v14.55c0 .99-.34 1.95-.96 2.73a4.7 4.7 0 0 1-5.38 1.4 4.56 4.56 0 0 1-2.22-1.88 4.39 4.39 0 0 1 .73-5.43 4.64 4.64 0 0 1 5.83-.52v-9.6L9.19 4.51V16.9a4.41 4.41 0 0 1-.96 2.56 4.7 4.7 0 0 1-5.38 1.4 4.56 4.56 0 0 1-2.23-1.89 4.39 4.39 0 0 1 .74-5.43 4.64 4.64 0 0 1 5.83-.51V4.5a2 2 0 0 1 1.56-1.95L19.98.02ZM4.25 14.27c-.57.07-1.1.32-1.5.71a2.39 2.39 0 0 0-.4 2.97c.27.47.7.84 1.24 1.06a2.7 2.7 0 0 0 1.68.1 2.6 2.6 0 0 0 1.39-.9c.34-.42.52-.95.53-1.49V15.7a6.49 6.49 0 0 0-1.02-.95 2.7 2.7 0 0 0-1.92-.48Zm12-1.2c-.57.07-1.1.33-1.5.72a2.39 2.39 0 0 0-.4 2.97c.27.46.7.84 1.24 1.05a2.7 2.7 0 0 0 1.68.1 2.6 2.6 0 0 0 1.39-.89c.34-.43.53-.96.53-1.5v-1.01l-.12-.14a6.48 6.48 0 0 0-.9-.81 2.7 2.7 0 0 0-1.92-.49Z"
  />,
  'Note2'
)
